export default __webpack_public_path__ + "static/leanGuides-e3ebc7c21516b170cb813d9a8e4b8801.webp";